<div class="row m-0 JobCard-Header" *ngIf="TotalRecords == 0">
  <div class=" col-md-12 p-0">
    <div class="alert alert-no-result-founds" role="alert">
      <div class="d-flex">
        <div class="info-icon">i</div>
        <div>
          <h1 class="mb-1 alert-heading">  No {{ contextService.IsJobSeeker ? "Jobs" : "CVs" }} found</h1>
          <p class="text-for-no-result">Your search for <strong>{{ResultsFoundFor}}</strong> didn't match any {{ contextService.IsJobSeeker ? "Jobs" : "CVs" }}.
            Can't find what you're looking for? Call our experts now on <strong>0330 172 8370</strong> and they will search everywhere online
            to find it for you.
          </p>
          <p class="mt-2"><i class="fa-solid fa-lightbulb"></i> <b> Suggestions:</b></p>
          <ul>
            <li>Check the spelling of your search keyword(s)</li>
            <li>Try different keyword</li>
            <li>Try to use more general keyword</li>
            <li>Replace abbreviations with whole keyword</li>
          </ul>
        </div>
      </div>
    </div>
    <!-- <div class="alert alert-info " role="alert">
      <h2>Suggested results to your search</h2>
      <p class="mt-2"><i class="fa fa-info-circle"></i> You search for:</p>
      <ul>
        <li>Keywords: {{SearchService?.SearchParams?.Keywords}}</li>
        <li>Delivered 0 result</li>
      </ul>
      <p class="mt-2"><i class="fa-solid fa-lightbulb"></i> <b> Suggestions:</b></p>
      <ul>
        <li>Check the spelling of your search keyword(s)</li>
        <li>Try different keyword</li>
        <li>Try to use more general keyword</li>
        <li>Replace abbreviations with whole keyword</li>
      </ul>
    </div> -->
  </div>
</div>

<div class="row m-0 JobCard-Header" *ngIf="TotalRecords != 0 && ShouldShowLocationMessage">
  <div class=" col-md-12 p-0">
    <div class="alert alert-no-result-founds" role="alert">
      <div class="d-flex">
        <div class="info-icon">i</div>
        <div>
          <h1 class="alert-heading mb-1">Oops!</h1>
          <p class="text-for-no-result" >
             Currently no {{ contextService.IsJobSeeker ? "Jobs" : "CVs" }} found in <strong> {{InLocation }}</strong>, {{ radius}} Miles. Displaying the most recently posted {{ contextService.IsJobSeeker ? "Jobs" : "CVs" }} instead. Refine your search or call our experts on <strong>0330 172 8370</strong> for assistance.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row m-0 JobCard-Header p-0" *ngIf="SearchService.SearchParams.SortBy.toLowerCase() == 'date' && SearchService.SearchParams.IsCustomSort && TotalRecords > 0">
  <div class="alert alert-warning " role="alert">
    <p>
      <!-- <i class="fas fa-bell notification-color"></i>
      The selected view only shows the most recent posts that are not in relevancy order. 
      <br> -->
      <i class="fa fa-info-circle notification-color" aria-hidden="true"></i> 
      Select Relevancy for better matching results! Try the "Search within last" filter for best results.
    </p>
  </div>
</div>

<div class="row m-0 JobCard-Header">
  <div class=" col-md-12 p-0">
    <h1 style="margin-bottom: 15px;" *ngIf="TotalRecords > 0">
      <span *ngIf="TotalRecords>0">{{TotalRecords}}</span><span *ngIf="TotalRecords >= 10000">+</span>
      {{ IsRemoteWork ? "remote work from home " : "" }}
      <span *ngIf="ResultsFoundFor != null" class="Keyword" (click)="onclick(true,false)">{{ResultsFoundFor}}</span>
      <span *ngIf="contextService.IsJobSeeker &&  ResultsFoundFor != '' && InLocation ==  ''">jobs found</span>
      <span *ngIf="contextService.IsRecruiter  &&  ResultsFoundFor != '' && InLocation ==  ''">CVs</span>
      <span *ngIf="InLocation != '' "> {{contextService.IsRecruiter ? 'CVs near' : 'jobs near '}}
        <span (click)="onclick(false,true)" class="location">{{InLocation}}</span>
      </span>
    
      <span *ngIf="ResultsFoundFor == '' &&  InLocation == '' ">{{SearchWithInText}}</span>
    </h1>
  </div>
</div>